<template>
  <div class="outgoing-message message listitems">
    <h5>{{ content.title }}</h5>
    <div v-for="listitem in content.items" :key="listitem.id" class="list-item clearfix">
      <div :class="{active: (listitem.image == null)}" class="textContainer">
        <h3>{{ listitem.title }}</h3>
        <h5>{{ listitem.subtitle }}</h5>
        <p>{{ listitem.text }}</p>
        <a
          v-if="listitem.link != null"
          :href="listitem.link"
          target="_blank"
          class="link"
        >{{ listitem.textlink }}</a>
      </div>
      <div v-if="listitem.image != null" class="imgContainer">
        <img :src="require(`@/assets/media/${ listitem.image }`)" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list",
  props: ["content"],
  data() {
    return {
      isImage: true
    };
  },
  mounted() {}
};
</script>
<style>
.listitems h5:first-child {
  text-align: center;
}
.listitems .list-item {
  margin: 0px -14px;
  padding: 14px;
}
.listitems .list-item .imgContainer {
  overflow: hidden;
  border-radius: 7px;
  float: right;
  width: 25%;
}
.listitems .list-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.listitems .list-item .textContainer {
  float: left;
  width: 70%;
  padding-right: 7px;
}
.listitems .list-item .textContainer.active {
  width: 100%;
}
.listitems .list-item h3 {
  font-size: 1.3em !important;
  margin-bottom: 3px;
}
.listitems .list-item h5 {
  font-size: 1.1em !important;
  margin-bottom: 2px;
}
.listitems .list-item p {
  font-size: 0.9em;
}
.listitems .link,
.list .link:hover,
.list .link:visited {
  border-radius: 7px;
  padding: 2px 16px;
  text-decoration: none;
}
.listitems .list-item.viewmore {
  text-align: center;
  display: block;
}
</style>